export const YearsRangeInfo = {
  MIN_YEAR: 1900,
  getMaxYear(): number {
    return new Date().getFullYear();
  },
};
